<template>
    <div style="display: contents;">

        <template v-for="structure in $props.dataRepoStructure.children">

            <tr v-if="structure.children.length">
                <td colspan="3" style="padding: 0px 2px;">
                    <v-expansion-panel :key="structure.node_id" style="background-color: #303030;">
                        <v-expansion-panel-header style="fontWeight: bold;">{{ structure.node_name }}</v-expansion-panel-header>
                        <v-expansion-panel-content>

                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead><tr>
                                        <th class="text-left">Name</th>
                                        <th class="text-left">Value</th>
                                        <th class="text-left" v-if="!$props.edit">Files</th>
                                    </tr></thead>
                                    <tbody>

                                        <data-repo-structure :dataRepoStructure="structure" :edit="$props.edit" :lockSave="$props.lockSave" :commonObjects="$props.commonObjects" @files="emitNodeFiles" />

                                    </tbody>
                                </template>
                            </v-simple-table>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </td>
            </tr>

            <data-repo-structure-node-row :node="structure" :edit="$props.edit" :lockSave="$props.lockSave" :commonObjects="$props.commonObjects" @files="$emit('files', structure)" v-if="!structure.children.length"></data-repo-structure-node-row>

        </template>

    </div>
</template>

<script>
import DataRepoStructureNodeRow from "@/components/Sites/DataRepoStructureNodeRow";
export default {
    name: 'DataRepoStructure',
    props: ['dataRepoStructure', 'edit', 'lockSave', 'commonObjects'],
    components: {
        DataRepoStructureNodeRow
    },
    data: () => ({
        expandedPanels: [],
        expanded: false,
        value: null
    }),

    computed: {
    },

    methods: {
        getNodeRawValue: function(node) {
            return node.value.node_value;
        },

        getNodeItemValue: function(node) {
            return node.value.node_value;
        },

        emitNodeFiles: function(node) {
            this.$emit('files', node);
        }
    },

    created() {
        
    },

    mounted() {
    },

    watch: {

    },

  
};
</script>

<style scoped>

    .sitebook-node-item-value {
        cursor: pointer;
        text-decoration: underline;
        color: aqua;
    }

    .sitebook-raw-value-input {
        padding-top: 0px;
        margin-top: 0px;
        min-height: 30px;
        height: 30px;
    }

</style>

<style>

    .sitebook-raw-value-input .v-input__slot {
        min-height: 30px !important;
        height: 30px !important;
    }

</style>
